module.exports = __webpack_public_path__ + "img/89.a4d478c.png";